import type { Client } from '../types';

export function sameClientId(
  a: number | string | null | undefined,
  b: number | string | null | undefined,
): boolean {
  if (a == null || b == null || a === '' || b === '') return false;
  const na = Number(a);
  const nb = Number(b);
  return Number.isFinite(na) && Number.isFinite(nb) && na === nb;
}

export function findClientById(
  clients: Client[],
  clientId: number | string | null | undefined,
): Client | undefined {
  return clients.find(c => sameClientId(c.client_id, clientId));
}

export function getClientDisplayName(
  clients: Client[],
  clientId: number | string | null | undefined,
): string {
  const client = findClientById(clients, clientId);
  if (client) {
    const name = `${client.first_name ?? ''} ${client.last_name ?? ''}`.trim();
    if (name) return name;
  }
  if (clientId != null && clientId !== '') return `Client ${clientId}`;
  return 'Unknown Client';
}
